import React from "react"

type IconProps = React.SVGProps<SVGSVGElement>

const PriceRangeIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8 13.45V3.55C8 3.24624 8.22386 3 8.5 3C8.77614 3 9 3.24624 9 3.55V13.45C9 13.7538 8.77614 14 8.5 14C8.22386 14 8 13.7538 8 13.45Z"
      fill="currentColor"
    />
    <path
      d="M10.6545 6.86951C10.6545 6.22113 10.034 5.47803 9 5.47803C7.96599 5.47803 7.34545 6.22113 7.34545 6.86951C7.34545 7.51788 7.96599 8.26099 9 8.26099C10.5367 8.26099 12 9.42561 12 11.1305C12 12.8354 10.5367 14 9 14C7.46331 14 6 12.8354 6 11.1305C6 10.7226 6.30141 10.3915 6.67273 10.3915C7.04404 10.3915 7.34545 10.7226 7.34545 11.1305C7.34545 11.7789 7.96599 12.522 9 12.522C10.034 12.522 10.6545 11.7789 10.6545 11.1305C10.6545 10.4821 10.034 9.73901 9 9.73901C7.46331 9.73901 6 8.57439 6 6.86951C6 5.16461 7.46331 4 9 4C10.5367 4 12 5.16461 12 6.86951C12 7.27741 11.6986 7.60852 11.3273 7.60852C10.956 7.60852 10.6545 7.27741 10.6545 6.86951Z"
      fill="currentColor"
    />
    <path
      d="M0 9C0 7.3621 0.438653 5.82355 1.2049 4.49893C1.43128 4.10822 1.93149 3.97456 2.32244 4.20064C2.71358 4.4269 2.847 4.92811 2.62074 5.31925C1.99485 6.4014 1.63636 7.65762 1.63636 9C1.63636 13.0668 4.93318 16.3636 9 16.3636C13.0668 16.3636 16.3636 13.0668 16.3636 9C16.3636 4.93318 13.0668 1.63636 9 1.63636C7.65762 1.63636 6.4014 1.99485 5.31925 2.62074C4.92811 2.847 4.4269 2.71358 4.20064 2.32244C3.97456 1.93149 4.10822 1.43128 4.49893 1.2049C5.82355 0.438653 7.3621 0 9 0C13.9705 2.81141e-07 18 4.02943 18 9C18 13.9705 13.9705 18 9 18C4.02943 18 2.81132e-07 13.9705 0 9Z"
      fill="currentColor"
    />
  </svg>
)

export default PriceRangeIcon
